import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '@mui/material';
import React from 'react';
import { FlexBox } from '../box';
import { IconButton } from '../button';
import { Drawer } from '.';
export const SIDE_NAV_WIDTH = 275;
export const SideNavigationDrawer = React.forwardRef(({ children, header, width = SIDE_NAV_WIDTH, open = true, onToggle, ...rest }, ref) => {
    const { palette, transitions, spacing, shape } = useTheme();
    return (_jsxs(FlexBox, { position: "relative", children: [onToggle && (_jsx(IconButton, { onClick: onToggle, color: "inherit", sx: {
                    position: 'absolute',
                    top: '200px',
                    right: 0,
                    transform: 'translateX(50%)',
                    zIndex: 999,
                    borderRadius: shape.borderRadius,
                    border: '1px solid',
                    borderColor: palette.elevation?.outlined,
                    transition: transitions.create(['left'], {
                        duration: transitions.duration.standard,
                        easing: transitions.easing.easeInOut
                    }),
                    background: palette.background.paper,
                    p: 0,
                    '&.MuiIconButton-root:hover': {
                        backgroundColor: palette.primary.main,
                        color: palette.background.paper,
                        border: 'none'
                    }
                }, icon: open ? 'IconChevronLeft' : 'IconChevronRight', iconProps: { fontSize: 'small' } })), _jsxs(Drawer, { ...rest, open: open, variant: "persistent", ref: ref, sx: {
                    width: open ? width : spacing(2),
                    flexShrink: 0,
                    position: 'relative',
                    transition: transitions.create(['width'], {
                        duration: transitions.duration.standard,
                        easing: transitions.easing.easeInOut
                    })
                }, slotProps: {
                    paper: {
                        sx: {
                            width: open ? width : 0,
                            border: 'none',
                            position: 'relative',
                            background: palette.background.default,
                            zIndex: 99
                        }
                    }
                }, children: [header && (_jsx(FlexBox, { pt: 2, pr: 2, pl: 2, width: "100%", children: header })), children] })] }));
});
